import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-md rounded-xl bg-card p-8 shadow-2xl">
        <h2 className="font-display text-xl font-semibold">Mot de passe oublié</h2>
        <p className="mt-1 text-sm text-muted-foreground">Saisissez votre e-mail pour générer un lien de réinitialisation.</p>
        {result ? (
          <div className="mt-6 space-y-4">
            <p className="text-sm" data-testid="forgot-success-message">{result.message}</p>
            {result.demo_reset_token && (
              <div className="rounded-md bg-muted p-3 text-xs">
                <p className="font-semibold">Mode démonstration (aucun service e-mail connecté) :</p>
                <Link
                  to={`/reset-password?token=${result.demo_reset_token}`}
                  className="mt-1 block break-all font-medium text-accent underline"
                  data-testid="demo-reset-link"
                >
                  Cliquer ici pour réinitialiser votre mot de passe
                </Link>
              </div>
            )}
            <Link to="/login" className="block text-center text-sm text-accent hover:underline">Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label>E-mail</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email-input" />
            </div>
            {error && <p className="text-sm text-destructive">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-submit-button">
              {loading ? "Envoi…" : "Générer le lien"}
            </Button>
            <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">Retour à la connexion</Link>
          </form>
        )}
      </div>
    </div>
  );
}
